const BASE_URL = "https://sourceunknown-api.lukuku.co/api";

async function fetchJson(url, options = {}) {
  try {
    const response = await fetch(`${BASE_URL}${url}`, options);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'API request failed');
    }
    return response.json();
  } catch (error) {
    console.error(`Error fetching ${url}:`, error);
    throw error;
  }
}
